<app-nav [isBanner]="false"></app-nav>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
